import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import InfoReviews from "@/components/InfoReviews.vue";
import GalleryMain from "@/components/GalleryMain.vue";
const UiMappers = Vue.extend({});
const DataMappers = Vue.extend({});
let ScreenReviews = class ScreenReviews extends Mixins(UiMappers, DataMappers) {
    constructor() {
        super(...arguments);
        this.slideImgs = [
            "/static/images/reviews/review-6.jpeg",
            "/static/images/reviews/review-5.jpeg",
            "/static/images/reviews/review-1.jpeg",
            "/static/images/reviews/review-2.jpeg",
            "/static/images/reviews/review-3.jpeg",
            "/static/images/reviews/review-4.jpeg",
            "/static/images/reviews/inst1.jpg",
            "/static/images/reviews/inst2.jpg",
            "/static/images/reviews/inst3.jpg",
            "/static/images/reviews/inst4.jpg",
        ];
    }
};
ScreenReviews = __decorate([
    Component({
        components: {
            InfoReviews,
            GalleryMain,
        },
    })
], ScreenReviews);
export default ScreenReviews;
